<template>
  <teleport to="body">
    <transition name="modal">
      <div
        v-if="props.show"
        class="modal"
        role="dialog"
        aria-modal="true"
        :class="{
          'modal--sm': props.size === 'sm',
          'modal--plain': props.variant === 'plain',
        }"
        @click.self="
          closable && !props.doNotCloseOnOutsideClick && emit('close')
        "
        @keydown.esc="
          closable && !props.doNotCloseOnOutsideClick && emit('close')
        "
      >
        <div class="modal__wrapper">
          <div
            v-if="showBackgroundImage"
            class="modal__bg"
            :style="{
              backgroundImage: 'url(' + (props.image ?? randomImage) + ')',
            }"
          ></div>
          <FocusTrap class="modal__body">
            <CloseButton
              v-if="closable && !props.hideClose"
              class="modal__close"
              @click="emit('close')"
            ></CloseButton>
            <slot></slot>
          </FocusTrap>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup lang="ts">
import FocusTrap from "./focus-trap.vue";

import img1 from "../assets/modal-bg/1@2x.jpg";
import img2 from "../assets/modal-bg/2@2x.jpg";
import img3 from "../assets/modal-bg/3@2x.jpg";
import CloseButton from "./close-button.vue";
import { computed, watchEffect } from "vue";

const randomImage = [img1, img2, img3].sort(() => 0.5 - Math.random())[0];

const props = defineProps<{
  show: boolean;
  size?: "sm";
  image?: string;
  unclosable?: boolean;
  variant?: "plain";
  doNotCloseOnOutsideClick?: boolean;
}>();

const closable = !props.unclosable;
const showBackgroundImage = computed(
  () => props.variant !== "plain" && props.size !== "sm"
);

const emit = defineEmits<{
  (e: "close"): void;
}>();

watchEffect(() => {
  if (props.show) {
    document.body.classList.add("is-modal-open");
  } else {
    document.body.classList.remove("is-modal-open");
  }
});
</script>
